import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { shallowEqual } from 'react-redux';
import { useAppSelector } from '../redux/store';
import { BadBeatJackpotExpandableDrawerSection } from './badBeatJackpotExpandableDrawerSection';
export const BadBeatJackpotExpandableDrawerContainer = ({ closeDrawer }) => {
    const badBeatJackpotProperties = useAppSelector((state) => state.session.badBeatJackpotProperties, shallowEqual);
    if (!badBeatJackpotProperties) {
        return null;
    }
    return (_jsx(BadBeatJackpotExpandableDrawerSection, { badBeatJackpotProperties: badBeatJackpotProperties, closeDrawer: closeDrawer }));
};
